import { useCurrentUser as useLinkfluenceCurrentUser } from "@linkfluence/core/user/use-cases";
import { User } from "@radarly/models/user";

export function useCurrentUser() {
  return useLinkfluenceCurrentUser() as User;
}
